export const SET_LANGUAGE = 'SET_LANGUAGE';
export function setLanguage(lang) {
    return function (dispatch) {
        dispatch({
            type: SET_LANGUAGE,
            payload: lang,
        });
    };
}
